'use strict';

var React = require('react');
var LabelParts = require('../common/LabelParts');
var styleHelper = require('../../helper/styleHelper');
var util = require('../../helper/util');

/**
 * 弹出选择条
 */
var ControlPopOver = React.createClass({

  _getCharacterCount: function (textArray) {
    var i = 0;
    var characterCount = 0;

    for (i = 0; i < textArray.length; i++) {
      if (textArray[i] === '') {
        characterCount = characterCount + 1;
      } else {
        characterCount = characterCount + textArray[i].length;
      }
    }

    return characterCount;
  },

  _getCharacterFixedSize: function (textArray) {
    return textArray.length * (this.marginHorizontal * 2 + this.separatorWidth) + this.rightWidth;
  },

  _getCorrectItems: function (textArray) {
    var textItems = [];
    var i = 0;

    for (i = 0; i < textArray.length; i++) {
      textItems.push(textArray[i]);
      textItems.push('_');    // separator
    }

    return textItems;
  },

  render: function () {
    this.rightWidth = 40;
    this.marginHorizontal = 10;
    this.marginVertical = 6;
    this.selectThumbHeight = 8;
    this.separatorWidth = 1;

    var textArray = util.Text.delimitText(styleHelper.getText(this.props), util.Text.DM_COMMA);
    var w = styleHelper.getWidth(this.props);
    var h = styleHelper.getHeight(this.props);
    var characterWidth = (w - this._getCharacterFixedSize(textArray)) / this._getCharacterCount(textArray);

    var backgroundStyle = {
      width: '100%',
      height: '100%'
    };

    var topBackgroundStyle = {
      width: w,
      height: h - this.selectThumbHeight,
      backgroundColor: '#000',
      borderRadius: 8,
      position: 'absolute',
      top: 0
    };

    var bottomBackgroundStyle = {
      width: w,
      height: this.selectThumbHeight,
      position: 'absolute',
      top: topBackgroundStyle.height + topBackgroundStyle.top
    };

    var itemStyle;
    var separatorStyle;
    var offset = 0;
    var textItems = this._getCorrectItems(textArray);
    var selectedIndexSize;
    var rightStyle = {
      right: 0,
      width: this.rightWidth,
      height: topBackgroundStyle.height,
      position: 'absolute',
      top: 0,
      borderRadius: 8
    };
    var rightTriangleStyle = {
      left: '50%',
      top: '50%',
      position: 'absolute',
      transform: 'translate(-50%, -50%)',
      width: 0,
      height: 0,
      borderTop: '6px solid transparent',
      borderBottom: '6px solid transparent',
      borderLeft: '12px solid #fff'
    };

    return (<div style={backgroundStyle}>
      <div style={topBackgroundStyle}>
        <div style={rightStyle}>
          <div style={rightTriangleStyle}></div>
        </div>
        {
          textItems.map(function (text, index) {

            if (index % 2 === 1) {
              separatorStyle = {
                width: this.separatorWidth,
                height: topBackgroundStyle.height,
                backgroundColor: '#fff',
                left: offset,
                position: 'absolute',
                top: 0
              };

              offset = offset + this.separatorWidth;

              return (<div key={'ControlPopOver item' + index} style={separatorStyle}></div>);
            }

            itemStyle = {
              position: 'absolute',
              left: offset + this.marginHorizontal,
              top: 0,
              width: characterWidth * (text ? text.length : 1),
              height: topBackgroundStyle.height,
              lineHeight: topBackgroundStyle.height  + 'px',
              textAlign: 'center',
              whiteSpace: 'nowrap',
              overflow: 'hidden',
              fontFamily : this.props.textFontFamily || decodeURIComponent(this.props.font.family),
            };

            if (index / 2 === this.state.selectedIndex) {
              selectedIndexSize = {
                left: itemStyle.left,
                width: itemStyle.width
              }
            }

            offset = offset + itemStyle.width + 2 * this.marginHorizontal;

            return (<div
              style={itemStyle}
              onClick={this.onItemClick.bind(this, null, index / 2)}>
              <LabelParts key={'ControlPopOver item' + index}  {...this.props} text={text}/>
            </div>);
          }.bind(this))
        }
      </div>
      <div style={bottomBackgroundStyle}>
        <div style={{
            position: 'absolute',
            left: selectedIndexSize.left,
            width: selectedIndexSize.width,
            height: bottomBackgroundStyle.height
        }}>
          <div style={{
            position: 'absolute',
            width: 0,
            height: 0,
            left: (selectedIndexSize.width - 12) / 2,
            borderLeft: '8px solid transparent',
            borderRight: '8px solid transparent',
            borderTop: '8px solid #000'
          }}></div>
        </div>
      </div>
    </div>);
  },

  getInitialState: function(){
    return {
      selectedIndex: this.props.selectedIndex
    }
  },

  onItemClick: function (e, index) {
    this.setState({selectedIndex: index});
  },

  componentDidMount: function(){
    $(ReactDOM.findDOMNode(this)).bind('itemClick', this.onItemClick);
  }
});

module.exports = ControlPopOver;



// WEBPACK FOOTER //
// ./src/views/Components/ControlPopOver.jsx